/**
 * AD Skipper for Youtube
 *
 * Declares a single web-accessible-resource — content.js — matched to every origin
 * (`<all_urls>`) with no `use_dynamic_url`. Though the content script itself only runs
 * on YouTube, that one WAR is fetchable at a fixed URL from any page, so a single fetch
 * that succeeds is conclusive: the file is served only when the extension is installed.
 *
 * Manifest verified against version 2.1.1.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'gideponcmplkbifbmopkmhncghnkpjng';

export const adSkipperForYoutube: ExtensionDefinition = {
  id: ID,
  name: 'AD Skipper for Youtube',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 20_000,
  notes:
    'Single WAR (content.js) exposed to every origin with no dynamic URL. The only ' +
    'bundled web-accessible file, but its presence at a fixed URL is conclusive.',
  signals: [
    {
      id: 'war-content-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch content.js — the extension\'s only web-accessible resource, exposed to ' +
        'every origin at a fixed URL.',
      weight: 1,
      run: () => probeFetch(ID, 'content.js'),
    },
  ],
};
